module.exports = __webpack_public_path__ + "img/2.12d8dc3f.png";